/**
 * 客户端渠道公用组件集合
 * 2019-6-11
 * Bai.Zhiming
 */
angular.module("appDirectiveModule",[
	"pushHeadDisabledEditDirModule",
	"addTagsModule"
]);